import { render, staticRenderFns } from "./ProjectBox.vue?vue&type=template&id=3a6ff268&scoped=true"
import script from "./ProjectBox.vue?vue&type=script&lang=js"
export * from "./ProjectBox.vue?vue&type=script&lang=js"
import style0 from "./ProjectBox.vue?vue&type=style&index=0&id=3a6ff268&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6ff268",
  null
  
)

export default component.exports